// src/components/ErrorBoundary.tsx
import React from 'react'

interface Props {
    children: React.ReactNode
}

interface State {
    hasError: boolean
    error?: Error
}
export class ErrorBoundary extends React.Component<Props, State> {
    public state: State = {
        hasError: false
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error }
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        // Add more detailed logging
        console.group('React Error Boundary Caught Error:')
        console.error('Error:', {
            message: error.message,
            stack: error.stack,
            name: error.name
        })
        console.error('Component Stack:', errorInfo.componentStack)
        console.groupEnd()
    }

    render(): React.ReactNode {
        if (this.state.hasError) {
            return (
                <div className="p-4 bg-red-50 border border-red-200 rounded">
                    <h2 className="text-red-800 font-bold">
                        Something went wrong
                    </h2>
                    <div className="mt-2 text-sm text-red-600">
                        <p className="font-semibold">Error Message:</p>
                        <pre className="mt-1 whitespace-pre-wrap">
                            {this.state.error?.message}
                        </pre>
                        <p className="font-semibold mt-4">Stack Trace:</p>
                        <pre className="mt-1 whitespace-pre-wrap">
                            {this.state.error?.stack}
                        </pre>
                    </div>
                </div>
            )
        }

        return this.props.children
    }
}
